import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
    Cell,
} from 'recharts';
import {Typography} from "@mui/material";

// Format x-axis ticks as "MM/DD HH:MM"
const formatXAxis = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d)) return '';
    const options = {month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false};
    return d.toLocaleString('en-US', options);
};

const CustomTooltip = ({active, payload, label}) => {
    if (active && payload && payload.length) {
        // Assume payload[0].payload contains time, players, and game fields.
        const data = payload[0].payload;
        return (
            <div style={{backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc'}}>
                <p style={{margin: 0}}><strong>{`Time: ${formatXAxis(data.time)}`}</strong></p>
                <p style={{margin: 0}}>{`Game: ${data.game}`}</p>
                <p style={{margin: 0}}>{`Players: ${data.players}`}</p>
            </div>
        );
    }
    return null;
};

const RowDataChart = ({rawData, title}) => {
    // Map rawData to chart data: each game session's start time and players.
    const chartData = rawData.map((item) => {
        const gameStart = item.attributes.gameStartDate;
        const players = item.attributes.score ?? 0;
        // Extract game name from game_variant if available.
        const game = item.attributes.game_variant &&
        item.attributes.game_variant.data &&
        item.attributes.game_variant.data.attributes &&
        item.attributes.game_variant.data.attributes.name
            ? item.attributes.game_variant.data.attributes.name
            : 'Unknown';

        const d = new Date(gameStart);
        // Determine if weekend: Sunday (0) or Saturday (6)
        const dayOfWeek = d.getUTCDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

        return {
            time: gameStart,
            players,
            game,
            fill: isWeekend ? '#0000FF' : '#008000', // Blue for weekends, green for weekdays
        };
    });
    // Sort data chronologically by game start time.
    chartData.sort((a, b) => new Date(a.time) - new Date(b.time));

    return (
        <div>
            <Typography variant="h5" align="center" gutterBottom>{title}</Typography>
            <ResponsiveContainer width="100%" height={400}>
                <BarChart data={chartData} margin={{top: 20, right: 30, left: 20, bottom: 5}}>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <XAxis dataKey="time" tickFormatter={formatXAxis}/>
                    <YAxis/>
                    <Tooltip content={<CustomTooltip/>}/>
                    <Bar dataKey="players" isAnimationActive={true}>
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.fill}/>
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default RowDataChart;
